import { Card, CardItem, Skeleton } from "@walmart-web/livingdesign-components"
import React from "react"
import "./SwitchingTreeSkeleton.scss"
import SwitchingNodeSkeleton from "./SwitchingNodeSkeleton"

const SwitchingTreeSkeleton = () => {
	return (
		<Card
			data-testid="switching-tree-loading"
			role="skeletonview"
			className="skeleton-container"
		>
			<CardItem className="card-item">
				<Skeleton variant="rectangle" height={30} width={800} />
			</CardItem>

			<div className="parent-node">
				<SwitchingNodeSkeleton />
			</div>

			<div
				style={{
					display: "flex",
					justifyContent: "center",
				}}
			>
				<svg height="100" width="100%" className="node-lines">
					<line x1="50%" y1="0" x2="50%" y2="200" />
					<line x1="20%" y1="60%" x2="80%" y2="60%" />
					<line x1="20%" y1="60%" x2="20%" y2="100%" />
					<line x1="80%" y1="60%" x2="80%" y2="100%" />
				</svg>
			</div>

			<div className="child-nodes">
				<SwitchingNodeSkeleton />
				<SwitchingNodeSkeleton />
				<SwitchingNodeSkeleton />
			</div>
		</Card>
	)
}

export default SwitchingTreeSkeleton
